import React, { useMemo, useState, useEffect } from "react";
import "./SupportPage.scss";
import { useParams } from "react-router-dom";
import { useContent } from "contexts/contentContext/contentContext.js";
import SupportCategories from "./SupportCategories";
import SupportHeader from "./SupportHeader";
import { getSingleQuestion, getSupportCategoryQuestions } from "./Helper.js";
import QuestionsList from "./QuestionsList";
import SideList from "./SideList";
import QuestionContent from "./QuestionContent";
import "react-loading-skeleton/dist/skeleton.css";
import config from "config";

const SupportPage = () => {
  const params = useParams();
  const { getSupportText, getLanguageCulture, getTextByKey, getPath } =
    useContent();
  const [supportMode, setSupportMode] = useState("home");
  const [loading, setLoading] = useState(false);
  const [questionDetails, setQuestionDetails] = useState(null);
  const [categoryQuestions, setCategoryQuestions] = useState(null);
  const [category, setCategory] = useState(null);
  const [notExistsPage, setNotExistsPage] = useState(false);

  useEffect(() => {
    if (notExistsPage) {
      //TODO: redirect to 404 page
      //get full error page url
      const errorPage = config.baseurl + getPath() + "error";
      window.location.href = errorPage;
    }
  }, [notExistsPage]);

  useMemo(() => {
    if (params.isQuestion && params.isQuestion !== undefined) {
      if (params.isQuestion !== "a") {
        //set the category
        const categories = getSupportText().categories;
        let tempCategory = {};
        if (params.isQuestion === "jumbo-forms") {
          tempCategory = categories.find((c) => c.SystemName === "jumbo-embed");
        } else {
          tempCategory = categories.find(
            (c) => c.SystemName === params.isQuestion
          );
        }
        if (tempCategory !== undefined) {
          getSupportCategoryQuestions(
            tempCategory.SystemName,
            getLanguageCulture(),
            setCategoryQuestions,
            setLoading,
            setNotExistsPage
          );
          setCategory(tempCategory);
          setSupportMode("categories");
        } else {
          setNotExistsPage(true);
        }
      } else {
        //set the question
        getSingleQuestion(
          getLanguageCulture(),
          params.supportQuestion,
          setQuestionDetails,
          setLoading,
          setNotExistsPage
        );
        setSupportMode("question");
      }
    }
  }, [params]);

  useEffect(() => {
    if (
      !category &&
      questionDetails &&
      questionDetails.SupportCategoryQuestionId > 0
    ) {
      const categories = getSupportText().categories;
      let tempCategory = {};
      if (questionDetails.CategoriesList[0] === "jumbo-forms") {
        tempCategory = categories.find((c) => c.SystemName === "jumbo-embed");
      } else {
        tempCategory = categories.find(
          (c) => c.SystemName === questionDetails.CategoriesList[0]
        );
      }
      setCategory(tempCategory);
      getSupportCategoryQuestions(
        questionDetails.CategoriesList[0],
        getLanguageCulture(),
        setCategoryQuestions,
        setLoading
      );
    }
  }, [questionDetails]);

  const skeletonLoader = (isQuestion) => {
    return (
      <div className="support-questions-page-container">
        <div className="support-questions-section categories-section skeleton-container">
          <QuestionsList isSkeleton={true} isQuestion={isQuestion} />
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="support-link-contact-us"
            href={`${getPath()}contact-us?subject=support`}
          >
            {getTextByKey("didnt-find-what-you-are-looking-for")}
          </a>
        </div>
        <SideList isSkeleton={true} />
      </div>
    );
  };

  return (
    <div
      className="support-page-container"
      style={{ backgroundColor: supportMode !== "home" ? "#f7f9f9" : "#fff" }}
    >
      <SupportHeader
        supportMode={supportMode}
        category={category}
        questionDetails={questionDetails}
      />
      <div
        className={`support-body ${
          supportMode === "home" ? "home-categories" : "question-body"
        }`}
      >
        {supportMode === "home" ? (
          <SupportCategories />
        ) : supportMode === "categories" ? (
          categoryQuestions ? (
            loading ? (
              // <div className="support-loading">
              //   <img
              //     className="loader-animation-gif"
              //     name="preloader" ext="gif"
              //     alt=""
              //     title=""
              //   />
              // </div>
              skeletonLoader(false)
            ) : (
              <div className="support-questions-page-container">
                <div className="support-questions-section categories-section">
                  <QuestionsList
                    category={category}
                    questionsList={categoryQuestions}
                  />
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="support-link-contact-us"
                    href={`${getPath()}contact-us?subject=support`}
                  >
                    {getTextByKey("didnt-find-what-you-are-looking-for")}
                  </a>
                </div>
                <SideList categories={getSupportText().categories} />
              </div>
            )
          ) : (
            skeletonLoader(false)
          )
        ) : supportMode === "question" ? (
          loading || !questionDetails || !categoryQuestions ? (
            skeletonLoader(true)
          ) : (
            // <div className="support-loading">
            //   <img
            //     className="loader-animation-gif"
            //     name="preloader" ext="gif"
            //     alt=""
            //     title=""
            //   />
            // </div>
            <QuestionContent
              questionDetails={questionDetails}
              questionsList={categoryQuestions}
            />
          )
        ) : (
          skeletonLoader(true)
        )}
      </div>
    </div>
  );
};

export default SupportPage;
